<template>
  <div class="stock_index_list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in tabList"
        :key="item"
        :label="$transform(item)"
        :name="item"
      ></el-tab-pane>
      <!-- <el-tab-pane :label="$transform('ASIA')" name="ASIA"></el-tab-pane>
      <el-tab-pane :label="$transform('EUR')" name="EUR"></el-tab-pane>
      <el-tab-pane
        :label="$transform('BONDS')"
        name="fouBONDSrth"
      ></el-tab-pane> -->
    </el-tabs>
    <div class="stock_list flex_start">
      <div
        class="stock_item flex_between"
        :class="{
          reduce: item.reduce,
          hasCharts: item.hasCharts,
          no_reduce_bg: !item.reduce && item.tabData['CHG'] == 'UNCH',
        }"
        v-for="(item, i) in stockList"
        @click="onToDetail(item)"
      >
        <div class="flex_between data_item">
          <div class="data_name">{{ item.name }}</div>
          <div v-if="item.tabType == 'BONDS'" class="last_data">
            {{ item.tabData.LAST }}%
          </div>
          <div v-else class="last_data">
            {{ item.tabData.LAST }}
          </div>
        </div>
        <div
          :class="
            item.tabData['CHG'] == 'UNCH'
              ? 'flex_between none_data'
              : 'flex_between up_data'
          "
        >
          <div v-if="!item.reduce" class="last_data">
            <template v-if="item.tabData['CHG'] == 'UNCH'">
              {{ item.tabData["CHG"] }}
            </template>
            <template v-else>
              +{{ item.tabData["CHG"] }} +{{ item.tabData["%CHG"] }}
            </template>
          </div>
          <div v-else="item.reduce" class="last_data">
            {{ item.tabData["CHG"] }} {{ item.tabData["%CHG"] }}
          </div>
        </div>
        <div class="stock_name">LAST | {{ item.tabData.DATA }}</div>
        <!--  PM CET -->
      </div>
      <div v-if="stockList.length == 0" class="flex_center empty">
        <el-empty
          :image-size="80"
          :description="$transform('NO DATA')"
        ></el-empty>
      </div>
    </div>
    <div class="bottom_tip">
      <bottom-tip></bottom-tip>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "",
      tabList: [],
      stockList: [],
    };
  },
  mounted() {
    this.loading = this.$loading();
    this.getTabList();
  },
  methods: {
    getTabList() {
      return this.$tool
        .fetchPost("/api/getCharts1TabList")
        .then((res) => {
          let { code, data } = res;
          if (code == 200) {
            this.tabList = data;
            this.activeName = data[0] || "";
            this.getStockList(this.activeName);
          }
        })
        .catch(() => {
          this.tabList = [
            "US",
            "ASIA",
            "EUR",
            "BONDS",
            "FX ASIA",
            "FX EUR",
            "COMDTY",
            "CRYPTO",
          ];
          this.activeName = "US";
          this.getStockList(this.activeName);

          // this.loading.close();
        });
    },
    getStockList(type) {
      return this.$tool
        .fetchPost("/api/getCharts1TabData", { type })
        .then((res) => {
          let { code, data } = res;
          data.forEach((item) => {
            item.reduce = item.tabData["increaseFlag"] == "2";
          });
          if (code == 200) {
            this.stockList = data.filter(
              (item) => item.tabData && Object.keys(item.tabData).length
            );
          }
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    handleClick({ name }) {
      // console.log(23);
      console.log(name);
      this.loading = this.$loading();
      this.getStockList(name);
    },
    onToDetail(item) {
      if (item.hasCharts == false) return;
      // console.log(process.env);
      window.parent.postMessage(
        JSON.stringify({
          type: "stockDetail",
          tabType: encodeURIComponent(this.activeName),
          tab: encodeURIComponent(item.name),
          path: "/product/stock-index-detail",
          url: `${
            window.location.origin
          }/product/stock-index-detail?tabType=${encodeURIComponent(
            this.activeName
          )}&tab=${encodeURIComponent(item.name)}`,
        }),
        "*"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
$max-width: 700px;
.stock_index_list {
  ::v-deep .el-tabs__nav-scroll {
    // overflow-x: scroll;
    scroll-behavior: smooth;
  }
  ::v-deep .el-tabs {
    flex: 1;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: #e5e5e5;
    // bottom: 3px;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #002f6c;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #005594;
  }
  ::v-deep .el-tabs__item {
    color: #747474;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 14px;
    font-family: SF-Pro-Display-Bold;
    text-transform: uppercase;
    font-weight: 300;
    &:hover {
      color: #2e2e2e;
    }
  }

  .stock_list {
    // flex-wrap: wrap;
    white-space: nowrap;
    display: block;
    overflow-x: scroll;
    .empty {
      width: 100%;
    }
    .stock_item {
      display: inline-flex;
      min-width: 195px;
      overflow-y: scroll;
      // @media screen and (max-width: $max-width) {
      //   width: 100%;
      //   margin-right: 0;
      // }
      cursor: default;
      &.hasCharts {
        cursor: pointer;
      }
      height: 84px;
      background: #008456;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      box-sizing: border-box;
      padding: 7px 10px;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 300;
      color: #ffffff;
      flex-direction: column;
      align-items: flex-start;
      margin-right: 24px;
      // margin-bottom: 20px;

      &:last-child {
        // margin-right: 0;
      }
      &.reduce {
        background-color: #ce282b;
        .up_data {
          &::before {
            transform: rotate(0deg);
          }
        }
      }
      &.no_reduce_bg {
        background-color: #9b9b9b;
      }

      .data_item {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (max-width: $max-width) {
          flex-direction: column;
          align-items: flex-start;
        }
        .data_name {
          font-size: 13px;
          font-family: SF-Pro-Display-Heavy;
          font-weight: 300;
          @media screen and (max-width: $max-width) {
            margin-bottom: 5px;
          }
        }
      }
      .last_data {
        font-family: SF-Pro-Display-Bold;
        font-weight: 300;
        font-size: 13px;
      }
      .up_data {
        width: 100%;
        &::before {
          content: "";
          height: 14px;
          width: 14px;
          // background: url("../assets/images/up_icon.png") no-repeat center
          //   center;
          // background-size: 100% 100%;
          border-left: 5px solid #0000;
          border-right: 5px solid #0000;
          height: 0;
          width: 0;
          border-top: 10px solid #fff;
          transform: rotate(180deg);
        }
        @media screen and (max-width: $max-width) {
          margin-bottom: 2px;
          margin-top: 2px;
        }
      }
      .none_data {
        width: 100%;
        &::before {
          content: "";
          height: 14px;
          width: 14px;
          // background: url("../assets/images/up_icon.png") no-repeat center
          //   center;
          // background-size: 100% 100%;
          border-left: 5px solid #0000;
          border-right: 5px solid #0000;
          height: 0;
          width: 0;
          border-top: 0px solid #fff;
          transform: rotate(180deg);
        }
      }
      .stock_name {
        width: 100%;
        font-size: 10px;
        font-weight: 300;
        color: #ffffff;
        opacity: 0.7;
        font-family: SF-Pro-Display-Bold;
        transform-origin: left center;
        transform: scale(0.9);
        font-weight: 300;
      }
    }
  }
  .bottom_tip {
    font-size: 12px;
    margin-top: 10px;
    font-weight: 400;
    color: #707070;
    text-align: center;
  }
}
</style>
